export default __webpack_public_path__ + "static/media/umidade.8d2399f5.png";